import { useNavigate } from 'react-router-dom';
import { PharmacyLayout } from '../pharmacy/PharmacyLayout';
import { PharmacySalesPanel } from '../pharmacy/PharmacySales';
import { usePharmacyTrashCount } from '../../services/httpServices/queries';
import { Plus, Trash2 } from 'lucide-react';

export function Pharmacy() {
  const navigate = useNavigate();
  const { count } = usePharmacyTrashCount();

  return (
    <PharmacyLayout
      title="Pharmacy"
      description="Sell medicines and accessories at the pharmacy counter"
      action={
        <>
          <button
            onClick={() => navigate('/pharmacy/trash')}
            className="px-4 py-2 bg-surface border border-border text-text rounded-lg hover:bg-background transition-colors text-sm font-medium flex items-center gap-2 shadow-sm"
            title="View trashed items"
          >
            <Trash2 size={16} />
            Trash
            {count > 0 && (
              <span className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-danger text-white text-xs font-semibold">
                {count > 99 ? '99+' : count}
              </span>
            )}
          </button>
          <button
            onClick={() => navigate('/pharmacy/new')}
            className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors text-sm font-medium flex items-center gap-2 shadow-sm"
          >
            <Plus size={16} />
            New Sale
          </button>
        </>
      }
    >
      <PharmacySalesPanel />
    </PharmacyLayout>
  );
}
